import { useLocation, useNavigate } from "react-router-dom";
import MenuMobile from "./MenuMobileBrad"; // Likely not needed if no mobile menu for login
import { useIsMobile } from "../../utils/useIsMobile";
import { useState } from "react";
import { getLogoImage } from "../../utils/getLogoImage";
import getThemeColors from "../../utils/getColorTheme";
import { useTheme } from "../../contexts/ThemeContext";

const HeaderPageLogin = () => { // Removed openModalLogin as it's not used for this version
  const location = useLocation();
  const navigate = useNavigate();
  const {addTheme} = useTheme();
  const logo = getLogoImage(addTheme); // This might need to be default logoDark for login
  const { theme, background } = getThemeColors(addTheme);
  const isMobile = useIsMobile();

  const isCurrentPath = (path) => location.pathname === path;

  // Simplified navigation for login page with unique IDs for hover state
  const navigationLinks = [
    {
      id: "chat",
      title: "Chat",
      action: () => navigate("/chat"),
      isActive: isCurrentPath("/chat"),
    },
  ];

  // const isHomePage = location.pathname === "/signin"; // Still useful for styling if needed

  return (
    <>
      <section
        className="d-flex justify-content-center align-items-center"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: isMobile ? "100%" : "calc(100% - 32px)",
          height: 72,
          zIndex: 100,
          background: background,
          padding: isMobile ? "0 24px" : "0 80px",
          marginLeft: isMobile ? "0" : "32px",
          boxSizing: "border-box"
        }}
      >
        <nav
          className="w-100 d-flex justify-content-between align-items-center"
          style={{ zIndex: 101, position: "absolute" }}
        >
          <div className="d-flex align-items-center" style={{ marginLeft: isMobile ? "20px" : "0" }}>
            <img
              src={logo}
              alt="Logo"
              width={60}
              height={20.3}
              className="cursor-pointer" // Removed v-hidden
              onClick={() => navigate("/chat")}
            />
          </div>
          <div className="d-flex align-items-center justify-content-end gap-4">
            {!isMobile && ( // Hide on mobile, as per typical pattern; adjust if mobile links needed
              <ul className="d-flex" style={{ gap: 24, marginRight: "20px"}}>
                {navigationLinks.map((item) => (
                  <li key={item.id} className="d-flex align-items-center">
                    <button
                      className={!item.isButton ? "nav-item-brad" : ""}
                      style={
                        item.isButton
                          ? {
                              backgroundColor: "#FFFFDF",
                              color: "#16140E",
                              borderRadius: "20px",
                              padding: "8px 16px",
                              border: "none",
                              cursor: "pointer",
                              fontWeight: 600,
                              fontSize: 16,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "40px",
                              transition: "all 0.2s ease",
                            }
                          : {
                              color: theme,
                              fontWeight: 600,
                              fontSize: 16,
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                              padding: "6px 2px",
                            }
                      }
                      onClick={item.action}
                      aria-label={`Navigate to ${item.title}`}
                    >
                      {item.title}
                    </button>
                  </li>
                ))}
              </ul>
            )}
            {/* Mobile menu icon can be added here if needed, but original request was no menu */}
            {/* {isMobile && <IconMenu2 className="cursor-pointer" onClick={() => setOpenMenuMobile(!openMenuMobile)}/>} */}
            {isMobile && (
              <ul className="d-flex" style={{ gap: 24, marginRight: "20px"}}>
                {navigationLinks.map((item) => (
                  <li key={item.id} className="d-flex align-items-center">
                    <button
                      className={!item.isButton ? "nav-item-brad" : ""}
                      style={
                        item.isButton
                          ? {
                              backgroundColor: "#FFFFDF",
                              color: "#16140E",
                              borderRadius: "20px",
                              padding: "6px 12px", // smaller padding for mobile
                              border: "none",
                              cursor: "pointer",
                              fontWeight: 600,
                              fontSize: 14, // Smaller font for mobile
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.2s ease",
                            }
                          : {
                              color: theme,
                              fontWeight: 600,
                              fontSize: 14, // Smaller font for mobile
                              position: "relative",
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                              padding: "4px 1px",
                            }
                      }
                      onClick={item.action}
                      aria-label={`Navigate to ${item.title}`}
                    >
                      {item.title}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </nav>
      </section>
      {/* {openMenuMobile && <MenuMobile setOpenMenuMobile={setOpenMenuMobile} />}  // No mobile menu for login */}
    </>
  );
};

export default HeaderPageLogin;
